export default {
    TITLE: "Редактирование доступа"
};
